import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import { useOrgModParams } from "src/features/orgmod";

const messages = defineMessages({
	acceptDataHandling1: {
		id: "form.add_or_edit_patient.accept_data_handling.1",
		defaultMessage: "Az"
	},
	acceptDataHandling2: {
		id: "form.add_or_edit_patient.accept_data_handling.2",
		defaultMessage: "adatkezelési betegtájékoztatót"
	},
	acceptDataHandling3: {
		id: "form.add_or_edit_patient.accept_data_handling.3",
		defaultMessage: "a pácinssel megismertettem, a"
	},
	acceptDataHandling4: {
		id: "form.add_or_edit_patient.accept_data_handling.4",
		defaultMessage: "TIMM hozzájáruló nyilatkozatot"
	},
	acceptDataHandling5: {
		id: "form.add_or_edit_patient.accept_data_handling.5",
		defaultMessage: ", valamint az"
	},
	acceptDataHandling6: {
		id: "form.add_or_edit_patient.accept_data_handling.6",
		defaultMessage: "OVSZ hozzájáruló nyilatkozatot"
	},
	acceptDataHandling7: {
		id: "form.add_or_edit_patient.accept_data_handling.7",
		defaultMessage: "a beteg aláírásával elfogadta."
	}
});

export const DataHandlingMessage: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "ktx" || mod === "kd") {
		return <DataHandlingMessageKtx />;
	}
	return <DataHandlingMessageCommon />;
};

const DataHandlingMessageCommon: React.FunctionComponent = () => {
	const { org, mod } = useOrgModParams();
	return (
		<>
			<FormattedMessage {...messages.acceptDataHandling1} />{" "}
			<a
				href={`/TIMM_Adatkezelesi_Betegtajekoztato.pdf`}
				target="_blank"
				rel="noreferrer"
			>
				<FormattedMessage {...messages.acceptDataHandling2} />
			</a>{" "}
			<FormattedMessage {...messages.acceptDataHandling3} />{" "}
			<a
				href={`/${org}__${mod}-doc.pdf`}
				target="_blank"
				rel="noreferrer"
			>
				<FormattedMessage {...messages.acceptDataHandling4} />
			</a>{" "}
			<FormattedMessage {...messages.acceptDataHandling7} />.
		</>
	);
};

const DataHandlingMessageKtx: React.FunctionComponent = () => (
	<>
		<FormattedMessage {...messages.acceptDataHandling1} />{" "}
		<a
			href="/TIMM_Adatkezelesi_Betegtajekoztato.pdf"
			target="_blank"
			rel="noreferrer"
		>
			<FormattedMessage {...messages.acceptDataHandling2} />
		</a>{" "}
		<FormattedMessage {...messages.acceptDataHandling3} />{" "}
		<a href="/ktx-doc.pdf" target="_blank" rel="noreferrer">
			<FormattedMessage {...messages.acceptDataHandling4} />
		</a>
		<FormattedMessage {...messages.acceptDataHandling5} />{" "}
		<a href="/ktx-ovsz-doc.pdf" target="_blank" rel="noreferrer">
			<FormattedMessage {...messages.acceptDataHandling6} />
		</a>{" "}
		<FormattedMessage {...messages.acceptDataHandling7} />
	</>
);
